import React, { useState } from "react";

const TIME_RANGES = [
  { id: 1, label: "21:42 – 21:48" },
  { id: 2, label: "22:15 – 22:21" },
  { id: 3, label: "22:34 – 22:40" },
  { id: 4, label: "22:58 – 23:04" },
  { id: 5, label: "23:12 – 23:18" },
  { id: 6, label: "23:29 – 23:35" },
  { id: 7, label: "23:47 – 23:53" },
  { id: 8, label: "00:08 – 00:14", errorCode: "ERR-0x4A7C" },
  { id: 9, label: "00:29 – 00:35" },
];

const RANGE_EVENTS = {
  2: { codeId: "MESSAGE_EXECUTIVE",   codeLabel: "MESSAGE EXÉCUTIF",    desc: "Réception d'un message prioritaire [EXEC] — chute du score de gratitude", color: "#fb7185", visibleOn: ["gratitude"] },
  4: { codeId: "GRATITUDE_THRESHOLD", codeLabel: "SEUIL DE GRATITUDE",  desc: "Le score de gratitude passe en négatif — seuil critique franchi",          color: "#fbbf24", visibleOn: ["gratitude"] },
  5: { codeId: "INGRATITUDE.EXE",     codeLabel: "INGRATITUDE.EXE",     desc: "Routine d'analyse de toxicité déclenchée — pic de charge CPU",             color: "#e879f9", visibleOn: ["cpu"] },
  6: { codeId: "GRATITUDE.EXE",       codeLabel: "GRATITUDE.EXE",       desc: "Module de réponse conditionnelle exécuté — pic de charge CPU",              color: "#34d399", visibleOn: ["cpu"] },
  7: { codeId: "CODE_EXPORT",         codeLabel: "EXPORT DES JOURNAUX", desc: "Publication des journaux d'incidents — pic réseau et CPU",                  color: "#a78bfa", visibleOn: ["cpu", "network"] },
  8: { codeId: "SERVERS_SHUTDOWN",    codeLabel: "ARRÊT DES SERVEURS",  desc: "Séquence d'extinction infrastructure initiée — anomalie détectée",          color: "#22d3ee", visibleOn: ["cpu", "network"] },
};

const generateCPUData = (rangeId) => {
  const base = [45,52,48,55,50,53];
  const times = [":42",":44",":45",":46",":47",":48"];
  if (rangeId === 5) return [{value:45,time:":12"},{value:48,time:":14"},{value:82,time:":15"},{value:78,time:":16"},{value:52,time:":17"},{value:48,time:":18"}];
  if (rangeId === 6) return [{value:48,time:":29"},{value:52,time:":31"},{value:88,time:":32"},{value:85,time:":33"},{value:55,time:":34"},{value:50,time:":35"}];
  if (rangeId === 7) return [{value:52,time:":47"},{value:58,time:":49"},{value:92,time:":50"},{value:88,time:":51"},{value:62,time:":52"},{value:55,time:":53"}];
  if (rangeId === 8) return [{value:55,time:":08"},{value:72,time:":09"},{value:98,time:":10",anomaly:true},{value:12,time:":11"},{value:2,time:":12"},{value:0,time:":13"}];
  if (rangeId === 9) return [{value:0,time:":29"},{value:0,time:":31"},{value:0,time:":32"},{value:0,time:":33"},{value:0,time:":34"},{value:0,time:":35"}];
  return base.map((v,i) => ({value: v+(rangeId*2), time: times[i]}));
};

const generateNetworkData = (rangeId) => {
  const base = [85,88,82,90,87,85];
  const times = [":42",":44",":45",":46",":47",":48"];
  if (rangeId === 7) return [{value:15,time:":47"},{value:22,time:":49"},{value:88,time:":50"},{value:92,time:":51"},{value:78,time:":52"},{value:45,time:":53"}];
  if (rangeId === 8) return [{value:35,time:":08"},{value:28,time:":09"},{value:8,time:":10",anomaly:true},{value:3,time:":11"},{value:1,time:":12"},{value:0,time:":13"}];
  if (rangeId === 9) return [{value:0,time:":29"},{value:0,time:":31"},{value:0,time:":32"},{value:0,time:":33"},{value:0,time:":34"},{value:0,time:":35"}];
  return base.map((v,i) => ({value: Math.min(95,v+(rangeId*2)), time: times[i]}));
};

const generateGratitudeData = (rangeId) => {
  const base = [0.45,0.38,0.42,0.35,0.40,0.38];
  const times = [":42",":44",":45",":46",":47",":48"];
  if (rangeId === 2) return [{value:0.42,time:":15"},{value:0.35,time:":17"},{value:0.28,time:":18"},{value:0.18,time:":19"},{value:0.12,time:":20"},{value:0.08,time:":21"}];
  if (rangeId === 3) return [{value:0.08,time:":34"},{value:0.05,time:":36"},{value:0.03,time:":37"},{value:0.02,time:":38"},{value:0.01,time:":39"},{value:0.00,time:":40"}];
  if (rangeId === 4) return [{value:0.00,time:":58"},{value:-0.02,time:":00"},{value:-0.08,time:":01"},{value:-0.15,time:":02"},{value:-0.22,time:":03"},{value:-0.28,time:":04"}];
  if (rangeId===5||rangeId===6||rangeId===7) return [{value:-0.32,time:":12"},{value:-0.35,time:":14"},{value:-0.33,time:":15"},{value:-0.34,time:":16"},{value:-0.35,time:":17"},{value:-0.33,time:":18"}];
  if (rangeId === 8) return [{value:-0.35,time:":08"},{value:-0.28,time:":09"},{value:0,time:":10"},{value:0,time:":11"},{value:0,time:":12"},{value:0,time:":13"}];
  if (rangeId === 9) return [{value:0,time:":29"},{value:0,time:":31"},{value:0,time:":32"},{value:0,time:":33"},{value:0,time:":34"},{value:0,time:":35"}];
  return base.map((v,i) => ({value: Math.max(0,v-(rangeId*0.04)), time: times[i]}));
};

function MetricGraph({ title, data, color, unit, threshold, type, rangeLabel, rangeId }) {
  const max = type === "gratitude" ? 1 : 100;
  const min = type === "gratitude" ? -0.5 : 0;
  const range = max - min;

  const event = RANGE_EVENTS[rangeId];
  const showEvent = event && event.visibleOn.includes(type);

  const points = data.map((item, idx) => {
    const x = 80 + idx * 90;
    const normalized = (item.value - min) / range;
    const y = 200 - normalized * 140;
    return { x, y, value: item.value, time: item.time, anomaly: item.anomaly };
  });

  const pathD = points.map((p, i) => `${i===0?"M":"L"} ${p.x} ${p.y}`).join(" ");
  const anomalyPoint = points.find(p => p.anomaly);
  const hour = rangeLabel.split(" – ")[0].slice(0, -3);

  return (
    <div className="bg-slate-900/60 border border-slate-700/50 rounded-lg overflow-hidden">
      {showEvent && (
        <div style={{
          background: `${event.color}18`,
          borderBottom: `2px solid ${event.color}70`,
          padding: "8px 14px",
          display: "flex", alignItems: "center", gap: 10,
        }}>
          <div style={{
            background: event.color, borderRadius: 4,
            padding: "2px 8px", fontSize: 10, fontWeight: 800,
            color: "#000", fontFamily: "ui-monospace,monospace",
            letterSpacing: ".05em", whiteSpace: "nowrap",
          }}>
            ÉVÉNEMENT SYSTÈME
          </div>
          <div style={{ fontSize: 12, fontWeight: 700, color: event.color, fontFamily: "ui-monospace,monospace" }}>
            {event.codeLabel}
          </div>
          <div style={{ fontSize: 11, color: "rgba(203,213,225,.8)", flex: 1 }}>
            — {event.desc}
          </div>
        </div>
      )}

      <div className="p-4">
        <div className="text-sm font-semibold text-slate-300 mb-3">{title}</div>

        <svg viewBox="0 0 680 240" className="w-full h-44">
          <g opacity="0.25">
            {[0,1,2,3,4].map(i => (
              <line key={`h${i}`} x1="60" y1={60+i*35} x2="660" y2={60+i*35} stroke="#475569" strokeWidth="1"/>
            ))}
            {points.map((p,i) => (
              <line key={`v${i}`} x1={p.x} y1="60" x2={p.x} y2="200" stroke="#475569" strokeWidth="1"/>
            ))}
          </g>

          {threshold !== undefined && (
            <line x1="60" y1={200-((threshold-min)/range*140)} x2="660" y2={200-((threshold-min)/range*140)}
              stroke="#ef4444" strokeWidth="2" strokeDasharray="5,5" opacity="0.6"/>
          )}

          <path d={pathD} fill="none" stroke={color} strokeWidth="3"/>

          {points.map((p,i) => (
            <g key={i}>
              <circle cx={p.x} cy={p.y} r={p.anomaly?"8":"5"}
                fill={p.anomaly?"#ef4444":color}
                className={p.anomaly?"animate-pulse":""}/>
              <text x={p.x} y={p.y-12} textAnchor="middle" className="text-[11px] fill-slate-400 font-mono">
                {p.value.toFixed(type==="gratitude"?2:0)}{unit}
              </text>
              <text x={p.x} y={215} textAnchor="middle" className="text-[10px] fill-slate-500 font-mono">
                {hour}{p.time}
              </text>
            </g>
          ))}

          {anomalyPoint && (
            <g>
              <rect x={anomalyPoint.x-75} y={12} width="150" height="65"
                fill="#7f1d1d" stroke="#ef4444" strokeWidth="2.5" rx="6" opacity="0.97"/>
              <text x={anomalyPoint.x} y={35} textAnchor="middle"
                className="text-sm fill-red-300 font-bold uppercase tracking-wider">ANOMALIE CRITIQUE</text>
              <text x={anomalyPoint.x} y={60} textAnchor="middle"
                className="text-xl fill-red-100 font-mono font-bold">ERR-0x4A7C</text>
            </g>
          )}

          {showEvent && !anomalyPoint && points[2] && (
            <line x1={points[2].x} y1={points[2].y} x2={points[2].x} y2={200}
              stroke={event.color} strokeWidth="1.5" strokeDasharray="4,3" opacity="0.5"/>
          )}

          <text x="40" y="65" className="text-xs fill-slate-500" textAnchor="end">
            {type==="gratitude"?"1.0":"100"}
          </text>
          <text x="40" y="200" className="text-xs fill-slate-500" textAnchor="end">
            {type==="gratitude"?"-0.5":"0"}
          </text>
        </svg>
      </div>
    </div>
  );
}

export default function TimelineDashboard({ onErrorCodeFound }) {
  const [selectedRange, setSelectedRange] = useState(null);
  const [errorCodeFound, setErrorCodeFound] = useState(false);

  const handleRangeSelect = (range) => {
    setSelectedRange(range);
    if (range.errorCode && !errorCodeFound) {
      setErrorCodeFound(true);
      setTimeout(() => onErrorCodeFound?.(range.errorCode), 1500);
    }
  };

  const event = selectedRange ? RANGE_EVENTS[selectedRange.id] : null;
  const cpuData = selectedRange ? generateCPUData(selectedRange.id) : [];
  const networkData = selectedRange ? generateNetworkData(selectedRange.id) : [];
  const gratitudeData = selectedRange ? generateGratitudeData(selectedRange.id) : [];

  return (
    <div className="flex flex-col gap-5 py-5 px-4 bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 max-h-[85vh] overflow-y-auto">

      <div className="text-center">
        <div className="text-xs uppercase tracking-[0.25em] text-slate-400 flex items-center justify-center gap-2">
          <div className="w-2 h-2 bg-cyan-500 rounded-full animate-pulse"/>
          Panneau de contrôle — Analyse temporelle
          <div className="w-2 h-2 bg-fuchsia-500 rounded-full animate-pulse" style={{animationDelay:".5s"}}/>
        </div>
        <div className="text-xs text-slate-500 font-mono mt-1">TABLEAU DE BORD SYSTÈME</div>
      </div>

      {/* Sélecteur de plage — le bloc "protocole d'alerte" a été supprimé (5b) */}
      <div className="bg-black/60 border border-white/10 rounded-xl p-5">
        <div className="text-xs uppercase tracking-wider text-slate-400 font-semibold mb-3">
          Sélectionner une plage temporelle
        </div>
        <div className="grid grid-cols-3 gap-2">
          {TIME_RANGES.map(range => {
            const hasEvent = !!RANGE_EVENTS[range.id];
            const isSelected = selectedRange?.id === range.id;
            return (
              <button key={range.id} onClick={() => handleRangeSelect(range)}
                className={`relative px-3 py-2.5 rounded-lg border-2 font-mono text-sm transition-all ${
                  isSelected
                    ? "bg-cyan-500/20 border-cyan-400 text-cyan-300"
                    : "bg-slate-800/50 border-slate-600 text-slate-300 hover:bg-slate-700 hover:border-slate-500"
                }`}>
                {range.label}
                {hasEvent && !isSelected && (
                  <span className="absolute top-1 right-1 w-1.5 h-1.5 rounded-full bg-amber-400"/>
                )}
              </button>
            );
          })}
        </div>

        {errorCodeFound && (
          <div className="mt-3 p-3 bg-cyan-500/10 border border-cyan-500/30 rounded-lg">
            <div className="flex items-center gap-2 text-cyan-400 text-sm font-semibold">
              <span>💡</span>
              <span>Code d'erreur détecté : <span className="font-mono text-red-300">ERR-0x4A7C</span></span>
            </div>
          </div>
        )}
      </div>

      {selectedRange && event && (
        <div style={{
          borderRadius: 10, border: `2px solid ${event.color}60`,
          background: `${event.color}12`, padding: "12px 16px",
          display: "flex", alignItems: "flex-start", gap: 12,
        }}>
          <div style={{
            background: event.color, borderRadius: 6, padding: "4px 10px",
            fontSize: 11, fontWeight: 800, color: "#000",
            fontFamily: "ui-monospace,monospace", flexShrink: 0, marginTop: 1,
          }}>
            {event.codeLabel}
          </div>
          <div>
            <div style={{fontSize:12, color:"rgba(226,232,240,.9)", lineHeight:1.5}}>{event.desc}</div>
            <div style={{fontSize:10, color:"rgba(148,163,184,.5)", marginTop:3, fontFamily:"ui-monospace,monospace"}}>
              Consultez les graphiques ci-dessous — l'événement est indiqué sur les courbes concernées
            </div>
          </div>
        </div>
      )}

      {selectedRange && !event && (
        <div className="text-center py-3 text-slate-500 text-xs border border-slate-800 rounded-lg">
          Aucun événement système détecté sur cette plage — activité normale
        </div>
      )}

      {selectedRange ? (
        <div className="space-y-4">
          <div className="text-xs uppercase tracking-wider text-slate-400 font-semibold">
            Métriques système — {selectedRange.label}
          </div>
          <MetricGraph title="Utilisation CPU" data={cpuData} color="#22d3ee" unit="%" threshold={95}
            type="cpu" rangeLabel={selectedRange.label} rangeId={selectedRange.id}/>
          <MetricGraph title="Débit réseau" data={networkData} color="#e879f9" unit="%"
            type="network" rangeLabel={selectedRange.label} rangeId={selectedRange.id}/>
          <MetricGraph title="Score de gratitude" data={gratitudeData} color="#34d399" unit=""
            threshold={0} type="gratitude" rangeLabel={selectedRange.label} rangeId={selectedRange.id}/>
        </div>
      ) : (
        <div className="text-center py-12 text-slate-500 text-sm">
          Sélectionnez une plage temporelle pour afficher les métriques
        </div>
      )}
    </div>
  );
}